import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })


export class RewardProductsDataService {
  private experienceProductsPagedData: BehaviorSubject<savedProductData>;
  private liveEventProductsPagedData: BehaviorSubject<savedProductData>;
  private companyExclusiveProductsPagedData: BehaviorSubject<savedProductData>;
  private physicalProductsPagedData: BehaviorSubject<savedProductData>;

  constructor() {
    this.experienceProductsPagedData = new BehaviorSubject({ data: [], filters: null });
    this.liveEventProductsPagedData = new BehaviorSubject({ data: [], filters: null });
    this.companyExclusiveProductsPagedData = new BehaviorSubject({ data: [], filters: null });
    this.physicalProductsPagedData = new BehaviorSubject({ data: [], filters: null });
  }

  public setExperienceProductsPagedDataValues(data, filters) {
    this.experienceProductsPagedData.next({ data: data, filters: filters });
  }

  public getExperienceProductsPagedDataValues(): Observable<savedProductData> {
    return this.experienceProductsPagedData.asObservable().pipe(take(1));
  }

  public setLiveEventProductsPagedDataValues(data, filters) {
    this.liveEventProductsPagedData.next({ data: data, filters: filters });
  }

  public getLiveEventProductsPagedDataValues(): Observable<savedProductData> {
    return this.liveEventProductsPagedData.asObservable().pipe(take(1));
  }

  public setCompanyExclusiveProductsPagedDataValues(data, filters) {
    this.companyExclusiveProductsPagedData.next({ data: data, filters: filters });
  }

  public getCompanyExclusiveProductsPagedDataValues(): Observable<savedProductData> {
    return this.companyExclusiveProductsPagedData.asObservable().pipe(take(1));
  }

  public setPhysicalProductsPagedDataValues(data, filters) {
    return this.physicalProductsPagedData.next({ data: data, filters: filters })
  }

  public getPhysicalProductsPagedDataValues(): Observable<savedProductData> {
    return this.physicalProductsPagedData.asObservable().pipe(take(1));
  }
}

interface savedProductData {
  data: any[];
  filters: any;
}
